import gql from 'graphql-tag'

export const getPolicyEndorsements = gql`
  query($policyId: Int!) {
    getPolicyEndorsements(
      policyId: $policyId
    ) {
      id
      policyName
      status
      type
      effectiveDate
      expirationDate
      originalInceptionDate
      brokerFee
      agencyFee
      carrierPolicyFee
      inspectionFee
      taxesFee
      stampingFee
      premium
      policyNumber
      term
      bindDate
      closed
      cancelDate
      createdAt
      updatedAt
      caseId
      additionalInfoStr
      installmentPlan
      billingType
      totalProjectedPremium
      totalProjectedCommission
      productCommissionOverride
      nonRenew
      note
      book {
        id
        name
      }
      account {
        id
        name
      }
      primaryContact {
        id
        name
      }
      source {
        id
        name
      }
      carrier {
        id
        name
      }
      carrierProduct {
        id
        name
      }
      generalAgent {
        id
        name
      }
      recordType {
        id
        name
      }
      insuranceQuote {
        id
        name
      }
      createdBy {
        id
        username
      }
    }
  }
`

export const newEndorsement = gql`
  mutation($policyId: Int!, $input: NewPolicyInput!, $note: String) {
    newEndorsement(
      policyId: $policyId,
      input: $input,
      note: $note
    )
  }
`
